import LoadContentBase from '../load-content/load-content-base';
import { hasClass } from '@opten/dom/has-class';
const stringCollapse = 'VehicleSliderSlideLoadContent';

export class VehicleSliderSlideLoadContent extends LoadContentBase {

	constructor(vehicleSliderSlide: HTMLElement) {
		const element = vehicleSliderSlide.querySelector('.js-vehicle-slider-slide-load-content') as HTMLElement;
		super(element);
	}

	static getInstance(
		element: HTMLElement,
		create = true
	) {
		let data = element[stringCollapse] as VehicleSliderSlideLoadContent;

		if (!data && create) {
			data = new VehicleSliderSlideLoadContent(element);
		}

		return data;
	}

	handleLoadVehicleSliderSlideContent() {
		if (this.contentElement && this.contentLoaded == false) {
			this.handleLoadContent();
		}
	}
}
